import type { DishesAction } from './DishActions';
import {
  CLOSE_MENU_ITEM_MODAL,
  OPEN_MENU_ITEM_MODAL,
} from './DishActions';
import type { DishesState } from './DishesState';

const initialState: DishesState = {
  menuEnabled: true,
  menuItemId: null,
  menuItemSource: 'menuItemCard',
  menuOrderingUrl: null,
  scheduledAt: null,
  showMenuItemModal: false,
};

const dishes = (state: DishesState = initialState, action: DishesAction) => {
  switch (action.type) {
    case CLOSE_MENU_ITEM_MODAL:
      return {
        ...state,
        menuOrderingUrl: null,
        scheduledAt: null,
        showMenuItemModal: false,
      };

    case OPEN_MENU_ITEM_MODAL:
      return {
        ...state,
        menuEnabled: action.menuEnabled,
        menuItemId: action.menuItemId,
        menuItemSource: action.menuItemSource,
        menuOrderingUrl: action.menuOrderingUrl,
        scheduledAt: action.scheduledAt,
        showMenuItemModal: true,
      };

    default:
      return state;
  }
};

export default dishes;
